import { render, staticRenderFns } from "./view-label.vue?vue&type=template&id=792ecf52"
import script from "./view-label.vue?vue&type=script&lang=js"
export * from "./view-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792ecf52')) {
      api.createRecord('792ecf52', component.options)
    } else {
      api.reload('792ecf52', component.options)
    }
    module.hot.accept("./view-label.vue?vue&type=template&id=792ecf52", function () {
      api.rerender('792ecf52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/view-label.vue"
export default component.exports